import { Card, Col, Drawer, Row } from 'antd';
import MapBlock from '../../components/MapBlock/MapBlock.jsx';
import CenterHomeFilters from '../../components/CenterHomeFilters/CenterHomeFilters.jsx';
import CenterHomePopup from '../../components/CenterHomePopup/CenterHomePopup.jsx';
import CenterHomeMobilePopup from '../../components/CenterHomePopup/CenterHomeMobilePopup.jsx';

function CenterHome() {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '1120px',
        margin: '0 auto',
        height: '100%',
      }}
    >
      <Row gutter={[20, 0]} style={{ height: '100%' }}>
        <Col style={{ width: '100%' }}>
          <CenterHomeFilters />
          <Card
            className="map_card"
            style={{ height: 720 }}
            bodyStyle={{ height: '100%' }}
          >
            <MapBlock />
          </Card>
          <CenterHomeMobilePopup />
        </Col>
      </Row>
    </div>
  );
}

export default CenterHome;
